import React from "react";
import Section1 from "./Section1";
import Header from "../Home/Header";
import Footer from "../Home/Footer";
// import Section2 from "./Section2";
function IndexInsurance() {
  return (
    <div>
      <Header />
      <Section1 />
      {/* <Section2 /> */}
      <Footer />
    </div>
  );
}

export default IndexInsurance;
